import {Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from "@angular/core";
import {FinalPackageDocumentPreview, TaxReturnPackageGeneration, FinalPackagePreview, PopulationService, TaxReturnService, PutFinalPackageBody} from "../../../../swaggerServices";
import {UserInfoService} from "../../../app/user-info.service";
import {ConfigStateService} from "../../../app/config/config-state.service";
import {AssignedUser} from "../../../app/tax-returns/tax-return/model/assigned-user";
import {TaxReturnAction, TaxReturnStep, TaxReturnStatus} from "../../../app/tax-returns/tax-return/model/status";
import {ITaxReturn} from "../../../app/tax-returns/tax-return/model/i-tax-return";
import {Observable, Subscription} from "rxjs";
import {SubcategoryComponent} from "../../../app/tax-returns/tax-return/subcategory/subcategory.component";
import {ClientNotificationService} from "../../../app/client-notification.service";
import { Tenant } from "../../types/tenant.enum";
import { BulkActionStatus } from "../../../app/tax-returns/tax-return/model/bulk-action-status";
import { TenantConfigService } from "../../services/tenant-config.service";
import { TranslocoService} from "@jsverse/transloco";
import { MatDialog } from "@angular/material/dialog";
import { BulkProcessNoQnrComponent } from "./bulk-process-no-qnr/bulk-process-no-qnr.component";
import { GenerateType, TemplateGenerationSelectionComponent } from "./template-generation-selection/template-generation-selection.component";
import { PreviewFinalPackageComponent } from "./preview-final-package/preview-final-package.component";
import { AmendConfirmationComponent } from "./amend-confirmation/amend-confirmation.component";
import { RejectConfirmationComponent } from "./reject-confirmation/reject-confirmation.component";
import { TaxreturnApprovalConfirmationComponent } from "./approval-confirmation/approval-confirmation.component";
import { ReviseConfirmationComponent } from "./revise-confirmation/revise-confirmation.component";
import { ComponentType } from "@angular/cdk/overlay";


declare const $: any;

const el = elementRef => $(elementRef.nativeElement);

type TaxReturnActionType =
  | 'finalPackageSelection'
  | 'revise'
  | 'previewFinalPackage'
  | 'approval'
  | 'reject'
  | 'amend';

interface ITaxReturnActionDataMap {
  finalPackageSelection: { generateType: GenerateType }
  revise: {}
  previewFinalPackage: {}
  approval: {}
  reject: {}
  amend: {}
}

@Component({
    selector: 'app-tax-return-actions',
    templateUrl: './tax-return-actions.component.html',
    styleUrls: ['./tax-return-actions.component.scss'],
    standalone: false
})
export class TaxReturnActionsComponent implements OnInit {
  @Output() refresh: EventEmitter<ITaxReturn> = new EventEmitter<ITaxReturn>();
  @Output() disableAllStartProcess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() disableBulkStartProcess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() shouldNavigateToTaxReturn: EventEmitter<ITaxReturn> = new EventEmitter<ITaxReturn>();
  @Output() shouldNavigateFromTaxReturn: EventEmitter<ITaxReturn> = new EventEmitter<ITaxReturn>();
  @Output() bulkActionComplete: EventEmitter<BulkActionStatus> = new EventEmitter<BulkActionStatus>();
  @ViewChild('wrongPermissionModal') wrongPermissionEl: ElementRef;
  wrongPermissionYouWerePreparer?: boolean; // false for reviewer, true for preparer
  @ViewChild('confirmPrepareTaxReturnModal') confirmPrepareReturnEl: ElementRef;
  @ViewChild('confirmBulkPrepareTaxReturnModal') confirmBulkPrepareReturnEl: ElementRef;
  @ViewChild('confirmReviewTaxReturnModal') confirmReviewReturnEl: ElementRef;
  @ViewChild('confirmBulkReviewTaxReturnModal') confirmBulkReviewReturnEl: ElementRef;
  reviewOrdinal?: string; // first/second
  @ViewChild('createTaxReturnModal') createReturnEl: ElementRef;
  @ViewChild('createAmendmentModal') createAmendmentEl: ElementRef;
  @ViewChild('actionConfirmationModal') actionConfirmationModalEl: ElementRef;
  @ViewChild('actionBulkConfirmationModal') actionBulkConfirmationModalEl: ElementRef;
  @ViewChild('actionSuccessModal') actionSuccessModalEl: ElementRef;
  @ViewChild('actionGenerateTaxReturnModal') actionGenerateTaxReturnModalEl: ElementRef;
  @ViewChild('createFinalPackageModal') createFinalPackageModalEl: ElementRef;
  @ViewChild('bulkGenerateModal') bulkGenerateModalEl: ElementRef;
  @ViewChild('bulkActionNotAvailableModal') bulkActionNotAvailableModalEl: ElementRef;
  @ViewChild('prefillResultsModal') prefillResultsModal: ElementRef;
  @ViewChild('confirmUploadLinkManuallyModal') confirmUploadLinkManuallyEl: ElementRef;
  @Input() bulk: boolean;
  actionConfirmationText?: string;
  actionSuccessText?: string;
  assignedUser?: AssignedUser;
  generatePackageResult?: TaxReturnPackageGeneration;
  bulkActioning? = {}; // "Bulk processing" something, e.g. assigning a preparer, the key is the tax return id, value is the action id
  actioning?: string; // a modal is "processing" something, e.g. assigning a preparer, the value is the action id
  // form control for create tax return modal
  apsTaxReturnId: string = "";
  finalPackagePreview?: FinalPackagePreview;
  sendConfirmationEmail: boolean = true;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  taxpayerAlias: string;
  isReady: boolean = false;
  isSaving: boolean;
  prefillResultsSummary: string[] = [];

  currentActionId: string;
  taxReturn: ITaxReturn;
  taxReturns: ITaxReturn[];
  generateType: string;
  finalPackgeCanSendToTaxpayer = false;
  finalPackgeCanSendToEmployer = false;
  constructor(private zone: NgZone,
              private userInfo: UserInfoService,
              private configState: ConfigStateService,
              private taxReturnService: TaxReturnService,
              private clientNotificationService: ClientNotificationService,
              private populationService: PopulationService,
              private translocoService: TranslocoService,
              private dialog: MatDialog) { }

  ngOnInit() {
    this.subscriptions.push(
      this.configState.loadConfig().subscribe(configState => {
        this.uiConfig = new TenantConfigService(configState);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias;
        this.translocoService.selectTranslate('tax-payer-alias').subscribe(value => this.taxpayerAlias = value);
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  }

  doAction(taxReturn: ITaxReturn, action: TaxReturnAction, populationId: number = null, updateReturn = false) {
    // Currently max 1 action in progress
    if (this.actioning != null) {
      return;
    }
    this.taxReturn = taxReturn;

    if (action.id === TaxReturnAction.CREATE.id) {
      this.createTaxReturn(taxReturn);
    } else if (action.id === TaxReturnAction.PRE_PREPARE.id) {
      this.prepareTaxReturn(taxReturn, updateReturn);
    } else if (action.id === TaxReturnAction.COMPLETE_PRE_PREPARE.id) {
      this.completePrePrepareTaxReturn(taxReturn, updateReturn);
    } else if (action.id === TaxReturnAction.PREPARE.id) {
      this.prepareTaxReturn(taxReturn);
    } else if (action.id === TaxReturnAction.REVIEW.id) {
      this.reviewTaxReturn(taxReturn);
    } else if (action.id === TaxReturnAction.CHECK_PREFILL_RUN_CALS.id) {
      this.checkPrefillRunCals(taxReturn);
    } else if (action.id === TaxReturnAction.GENERATE_TAX_PACKAGE.id || action.id === TaxReturnAction.GENERATE_FINAL_DOCUMENTS.id) {
      if (this.configState.tenant !== Tenant.AU && this.configState.tenant !== Tenant.ESS) {
        // Note: set generateType to STANDARD for SG as per backend expectation
        this.openActionDialog('finalPackageSelection', { generateType: 'STANDARD' });
      } else {
        this.generateTaxPackage(taxReturn, "DRAFT_WITH_TRANSITION");
      }
    } else if (action.id === TaxReturnAction.GENERATE_TAX_PACKAGE_FINAL.id || action.id === TaxReturnAction.GENERATE_FINAL_DOCUMENTS_FINAL.id) {
      if (this.configState.tenant !== Tenant.AU && this.configState.tenant !== Tenant.ESS) {
        // Note: set generateType to STANDARD for SG as per backend expectation
        this.openActionDialog('finalPackageSelection', { generateType: 'STANDARD' });
      } else {
        this.generateTaxPackage(taxReturn, "FINAL_REVIEW_AUTO");
      }
    } else if (action.id === TaxReturnAction.GENERATE_TAX_PACKAGE_MANUAL.id) {
      if (this.configState.tenant !== Tenant.AU && this.configState.tenant !== Tenant.ESS) {
        this.openActionDialog('finalPackageSelection', { generateType: 'STANDARD' });
      } else {
        this.generateTaxPackage(taxReturn, "FINAL_REVIEW_MANUAL");
      }
    } else if (action.id === TaxReturnAction.PREVIEW_FINAL_PACKAGE.id || action.id === TaxReturnAction.FILES_SENT_TO_CLIENT.id) {
      if (this.configState.tenant !== Tenant.AU && this.configState.tenant !== Tenant.ESS) {
        this.previewFinalPackage();
      } else {
        this.previewFinalPackageAU(taxReturn);
      }
    } else if (action.id === TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE.id) {
      this.previewFinalPackage();
    } else if (action.id === TaxReturnAction.SUBMIT_FOR_REVIEW.id) {
      this.submitForReview(taxReturn);
    } else if (action.id === TaxReturnAction.BACK_FOR_CHANGES.id) {
      this.backForChanges(taxReturn);
    } else if (action.id === TaxReturnAction.REVIEW_COMPLETED.id) {
      this.reviewCompleted(taxReturn);
    } else if (action.id === TaxReturnAction.SUBMIT_TO_ASSIGNEE.id) {
      this.submitToAssignee(taxReturn);
    } else if (action.id === TaxReturnAction.LINK_FAIL_UPLOAD_NEXT.id) {
      this.confirmUploadLinkManually(taxReturn);
    } else if (action.id === TaxReturnAction.TAXPAYER_ACCEPTED.id || action.id === TaxReturnAction.TAXPAYER_ACCEPTED_ARROW.id || action.id === TaxReturnAction.TAXPAYER_ACCEPTED_BUTTON.id|| action.id === TaxReturnAction.TAXPAYER_ACCEPTED_NEXT.id) {
      this.taxpayerAccepted(taxReturn);
    } else if (action.id === TaxReturnAction.TAXPAYER_REJECTED.id || action.id === TaxReturnAction.TAXPAYER_REJECTED_BUTTON.id || action.id === TaxReturnAction.TAXPAYER_REJECTED.id) {
      this.taxpayerRejected(taxReturn);
    } else if (action.id === TaxReturnAction.EMPLOYER_ACCEPTED.id || action.id === TaxReturnAction.EMPLOYER_ACCEPTED_NEXT.id|| action.id === TaxReturnAction.EMPLOYER_ACCEPTED_NEXT_BUTTON.id) {
      this.employerAccepted(taxReturn);
    } else if (action.id === TaxReturnAction.EMPLOYER_REJECTED.id|| action.id === TaxReturnAction.EMPLOYER_REJECTED_BACK.id|| action.id === TaxReturnAction.EMPLOYER_REJECTED_BACK_BUTTON.id) {
      this.employerRejected(taxReturn);
    } else if (action.id === TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED.id) {
      this.taxpayerEmployerAccepted(taxReturn);
    } else if (action.id === TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED.id) {
      this.taxpayerEmployerRejected(taxReturn);
    } else if (action.id === TaxReturnAction.REVISE.id || action.id === TaxReturnAction.REVISE_BACK_FOR_CHANGES.id || action.id === TaxReturnAction.REVISE_BACK_FOR_CHANGES_SECONDARY.id) {
      this.openActionDialog('revise', {});
    } else if (action.id === TaxReturnAction.LODGED.id || action.id === TaxReturnAction.LODGED_NEXT.id ||action.id === TaxReturnAction.LODGED_ARROW.id) {
      this.lodged(taxReturn);
    } else if (action.id === TaxReturnAction.AMEND.id) {
      this.amend(taxReturn);
    } else if (action.id === TaxReturnAction.PROCESS_NO_QNR.id) {
      this.processNoQnr(taxReturn, populationId);
    } else if (action.id === TaxReturnAction.BULK_PROCESS_NO_QNR.id) {
      this.setBulkProcess(taxReturn, populationId);
    } else if (action.id === TaxReturnAction.EXCEPTION_FILING.id) {
      this.exceptionFiling(taxReturn);
    } else if (action.id === TaxReturnAction.INFORMATION_NOT_COMPLETE.id) {
      this.informationNotComplete(taxReturn);
    } else if (action.id === TaxReturnAction.SEND_FOR_PRINTING.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_REJECT.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_ARROW.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_REFINE.id ) {
      this.sendForPrinting(taxReturn);
    } else if (action.id === TaxReturnAction.CHECK_PRINTED_PACKAGE.id) {
      this.checkPrintedPackage(taxReturn);
    } else if (action.id === TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND.id || action.id === TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND_ACCEPTED.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_CHECKING.id ) {
      this.readyToSend(taxReturn);
    } else if (action.id === TaxReturnAction.QUESTION_DRIVEN_STATUS.id ||action.id === TaxReturnAction.QUESTION_DRIVEN_STATUS_NEXT.id  ) {
      this.questionDrivenStatus(taxReturn);
    } else {
      console.log('Unknown action', action);
    }
  }

  generateTaxPackage(taxReturn: ITaxReturn, generateType: "DRAFT" | "DRAFT_WITH_TRANSITION" | "FINAL_REVIEW_AUTO" | "FINAL_REVIEW_MANUAL" | "STANDARD") {
    this.genericAction(
      taxReturn,
      TaxReturnAction.GENERATE_TAX_PACKAGE,
     `Are you sure you want to submit this ${this.taxReturnAlias} for package generation?`,
      data => data.messages.length > 0 ? data.messages[0] : {},
      'Failed to submit for tax package generation',
      this.taxReturnService.generateTaxReturnThroughRobot(taxReturn.id, generateType),
      this.shouldNavigateFromTaxReturn,
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  prepareTaxReturn(taxReturn: ITaxReturn, updateReturn = false) {
    const action = TaxReturnAction.PREPARE;

    const assignedUser = taxReturn.assignedUser;
    if (assignedUser && this.userInfo.id === assignedUser.id) {
      // already assigned to me, just view it
      if ((updateReturn && taxReturn.status === TaxReturnStatus.PRE_PREPARATION.id) || taxReturn.status === TaxReturnStatus.READY_FOR_PREPARATION.id) {
        this.actioning = action.id;
        this.taxReturnService.updateTaxReturnWithpreparer(taxReturn.id, {
          amendmentCount: taxReturn.amendmentCount,
          revisionCount: taxReturn.revisionCount,
        }).subscribe(() => {
          this.actioning = null;
          this.shouldNavigateToTaxReturn.emit(taxReturn);
        }, e => {
          this.actioning = null;
        });
      }
      this.shouldNavigateToTaxReturn.emit(taxReturn);
      return;
    }

    const reviewers: any[] = taxReturn.reviewer || [];
    if (reviewers.some(r => r.id === this.userInfo.id)) {
      // can't prepare if you were a reviewer
      this.wrongPermissionYouWerePreparer = false;
      this.showWrongPermissionModal();
    } else if (assignedUser) {
      // assigned to somebody else, ask to confirm
      this.assignedUser = assignedUser;
      this.showConfirmPrepareTaxReturnModal(taxReturn, () => {
        this.actioning = action.id;
        this.taxReturnService.updateTaxReturnWithpreparer(taxReturn.id, {
          amendmentCount: taxReturn.amendmentCount,
          revisionCount: taxReturn.revisionCount,
        }).subscribe(() => {
          this.actioning = null;
          this.closeConfirmPrepareTaxReturnModal();
          this.shouldNavigateToTaxReturn.emit(taxReturn);
        }, e => {
          this.actioning = null;
        });
        return false;
      });
    } else {
      // assigned to nobody, just take it
      this.actioning = action.id;
      this.taxReturnService.updateTaxReturnWithpreparer(taxReturn.id, {
        amendmentCount: taxReturn.amendmentCount,
        revisionCount: taxReturn.revisionCount,
      }).subscribe(() => {
        this.actioning = null;
        this.shouldNavigateToTaxReturn.emit(taxReturn);
      }, e => {
        this.actioning = null;
      });
    }
  }

  createErrorMessage(e) {
    let message = e && e.error && e.error.message ? e.error.message : '';
    if (!message) {
      message = e && e.message ? e.message : "Error occured, please see administrator"
    }
    return message;
  }

  bulkGeneratePackage() {
    this.showBulkGenerateModal();
  }
  bulkPrepareTaxReturn(taxReturns: ITaxReturn[], updateReturn = false) {
    const action = TaxReturnAction.PREPARE;

    const bulkUpdateTaxReturnWithpreparerRequests: ITaxReturn[] = [];
    const wrongPermissions: ITaxReturn[] = [];
    const assignedToSomeoneElseRequests: ITaxReturn[] = [];
    const justTakeItRequests: ITaxReturn[] = [];
    taxReturns.forEach(taxReturn => {
      const assignedUser = taxReturn.assignedUser;
      if (assignedUser && this.userInfo.id === assignedUser.id) {
        // already assigned to me, just view it
        if ((updateReturn && taxReturn.status === TaxReturnStatus.PRE_PREPARATION.id) || taxReturn.status === TaxReturnStatus.READY_FOR_PREPARATION.id) {
          bulkUpdateTaxReturnWithpreparerRequests.push(taxReturn)
          return;
        }
      }
      const reviewers: any[] = taxReturn.reviewer || [];
      if (reviewers.some(r => r.id === this.userInfo.id)) {
        // can't prepare if you were a reviewer
        wrongPermissions.push(taxReturn)
        this.bulkActionComplete.emit({taxReturnId:taxReturn.id, status: 'complete', success:false, message: 'You cannot prepare this return, you are already a reviewer'});
      } else if (assignedUser) {
        // assigned to somebody else, ask to confirm
        assignedToSomeoneElseRequests.push(taxReturn)
        return;
      } else {
        // assigned to nobody, just take it
        justTakeItRequests.push(taxReturn)
      }

    });

    this.showBulkConfirmPrepareTaxReturnModal(bulkUpdateTaxReturnWithpreparerRequests, wrongPermissions, assignedToSomeoneElseRequests, justTakeItRequests, () => {
      bulkUpdateTaxReturnWithpreparerRequests.forEach(taxReturn => {

            this.bulkActioning[taxReturn.id] = action.id;
           this.taxReturnService.updateTaxReturnWithpreparer(taxReturn.id, {
              amendmentCount: taxReturn.amendmentCount,
              revisionCount: taxReturn.revisionCount,
            }).subscribe(() => {
              delete this.bulkActioning[taxReturn.id];
              this.bulkActionComplete.emit({taxReturnId:taxReturn.id, success: true, status: 'complete'});
            }, e => {
              delete this.bulkActioning[taxReturn.id];
              this.bulkActionComplete.emit({taxReturnId:taxReturn.id, success: false, message: this.createErrorMessage(e), status: 'complete'});

            });
          })
          assignedToSomeoneElseRequests.forEach(taxReturn => {

            this.bulkActioning[taxReturn.id] = action.id;
           this.taxReturnService.updateTaxReturnWithpreparer(taxReturn.id, {
              amendmentCount: taxReturn.amendmentCount,
              revisionCount: taxReturn.revisionCount,
            }).subscribe(() => {
              delete this.bulkActioning[taxReturn.id];
              this.bulkActionComplete.emit({taxReturnId:taxReturn.id, success: true, status: 'complete'});
            }, e => {
              delete this.bulkActioning[taxReturn.id];
              this.bulkActionComplete.emit({taxReturnId:taxReturn.id, success: false, message:this.createErrorMessage(e), status: 'complete'});
            });
          })

          justTakeItRequests.forEach(taxReturn => {

            this.bulkActioning[taxReturn.id] = action.id;
           this.taxReturnService.updateTaxReturnWithpreparer(taxReturn.id, {
              amendmentCount: taxReturn.amendmentCount,
              revisionCount: taxReturn.revisionCount,
            }).subscribe(() => {
              delete this.bulkActioning[taxReturn.id];
              this.bulkActionComplete.emit({taxReturnId:taxReturn.id, success: true, status: 'complete'});
            }, e => {
              delete this.bulkActioning[taxReturn.id];
              this.bulkActionComplete.emit({taxReturnId:taxReturn.id, success: false, message:this.createErrorMessage(e), status: 'complete'});
            });
          })

      });
}


  genericBulkAction(taxReturns: ITaxReturn[],
    action: TaxReturnAction,
    confirmationText: string,
    successText: string | ((data: any) => string),
    errorText: string,
    updateObservableList: Observable<any>[],
    output: EventEmitter<BulkActionStatus>) {
    this.actionConfirmationText = confirmationText;
    this.showBulkActionConfirmationModal(() => {
      taxReturns.forEach((taxReturn: ITaxReturn, index: number) => {
        output.emit({taxReturnId:taxReturn.id, status: 'pending'});
        updateObservableList[index].subscribe((data: any) => {
          this.actionSuccessText = typeof successText === "string" ? successText : successText(data);
          output.emit({taxReturnId:taxReturn.id, success: true, status: 'complete'});
        }, (e) => {
          output.emit({taxReturnId:taxReturn.id, success: false, status: 'complete', message:this.createErrorMessage(e)});
        });
      })
    });
  }

  showConfirmPrepareTaxReturnModal(taxReturn: ITaxReturn, onApprove: () => void) {
    $(this.confirmPrepareReturnEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }

  showBulkGenerateModal(){
    $(this.bulkGenerateModalEl.nativeElement).modal({
      onApprove: () => {}
    }).modal("show");
  }
  showBulkActionNotAvailableModalModal(){
    $(this.bulkActionNotAvailableModalEl.nativeElement).modal({
      onApprove: () => {
        this.closeBulkActionNotAvailableModalModal();
      }
    }).modal("show");
  }
  closeBulkActionNotAvailableModalModal() {
    $(this.confirmBulkPrepareReturnEl.nativeElement).modal('hide');
  }

  showBulkConfirmPrepareTaxReturnModal(bulkUpdateTaxReturnWithpreparerRequests: ITaxReturn[] = [], wrongPermissions: ITaxReturn[] = [],assignedToSomeoneElseRequests: ITaxReturn[] = [],justTakeItRequests: ITaxReturn[] = [], onApprove: () => void) {
    $(this.confirmBulkPrepareReturnEl.nativeElement).modal({
      onApprove: () => {
        bulkUpdateTaxReturnWithpreparerRequests.forEach(taxReturn => {
            this.bulkActionComplete.emit({taxReturnId:taxReturn.id, status: 'pending'});
        })
        assignedToSomeoneElseRequests.forEach(taxReturn => {
            this.bulkActionComplete.emit({taxReturnId:taxReturn.id, status: 'pending'});
        })
        justTakeItRequests.forEach(taxReturn => {
          this.bulkActionComplete.emit({taxReturnId:taxReturn.id, status: 'pending'});
        })

        this.zone.run(onApprove);
        this.closeConfirmBulkPrepareTaxReturnModal();
        return false;
      },
    }).modal("show");
  }
  closeConfirmBulkPrepareTaxReturnModal() {
    $(this.confirmBulkPrepareReturnEl.nativeElement).modal('hide');
  }

  closeConfirmPrepareTaxReturnModal() {
    $(this.confirmPrepareReturnEl.nativeElement).modal('hide');
  }

  reviewTaxReturn(taxReturn: ITaxReturn, action: TaxReturnAction = TaxReturnAction.REVIEW) {
    const assignedUser = taxReturn.assignedUser;
    if (assignedUser && this.userInfo.id === assignedUser.id) {
      // already assigned to me, just view it
      this.shouldNavigateToTaxReturn.emit(taxReturn);
      return;
    }

    const setReviewer = () => {
      this.actioning = action.id;
      this.taxReturnService.updateTaxReturnWithreviewer(taxReturn.id).subscribe(() => {
        this.actioning = null;
        this.closeConfirmReviewTaxReturnModal();
        this.shouldNavigateToTaxReturn.emit(taxReturn);
      }, e => {
        this.actioning = null;
      });
    };

    const preparers: any[] = taxReturn.preparer || [];

    if (!this.configState.featureFlags.preparerCanReviewToo) {
      if (preparers.some(p => p.id === this.userInfo.id)) {
        // can't review if you were a preparer
          this.wrongPermissionYouWerePreparer = true;
          this.showWrongPermissionModal();
      } else if (assignedUser) {
        if (taxReturn.fullStatus.step === TaxReturnStep.FIRST_REVIEW) {
          this.reviewOrdinal = 'first';
        } else {
          this.reviewOrdinal = 'second';
        }
        this.assignedUser = assignedUser;
        this.showConfirmReviewTaxReturnModal(taxReturn, setReviewer);
      } else {
        setReviewer();
      }
    } else {
      if (preparers.some(p => p.id === this.userInfo.id) && preparers.length === 1) {
        // can't review if you were the only preparer
          this.wrongPermissionYouWerePreparer = true;
          this.showWrongPermissionModal();
      } else if (assignedUser) {
        if (taxReturn.fullStatus.step === TaxReturnStep.FIRST_REVIEW) {
          this.reviewOrdinal = 'first';
        } else {
          this.reviewOrdinal = 'second';
        }
        this.assignedUser = assignedUser;
        this.showConfirmReviewTaxReturnModal(taxReturn, setReviewer);
      } else {
        setReviewer();
      }
    }
  }

  showWrongPermissionModal() {
    $(this.wrongPermissionEl.nativeElement).modal("show");
  }

  showConfirmReviewTaxReturnModal(taxReturn: ITaxReturn, onApprove: () => void) {
    $(this.confirmReviewReturnEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }

  closeConfirmReviewTaxReturnModal() {
    $(this.confirmReviewReturnEl.nativeElement).modal('hide');
  }

  createTaxReturn(taxReturn: ITaxReturn) {
    this.apsTaxReturnId = '';
    this.showCreateTaxReturnModal(() => {
      this.actioning = TaxReturnAction.CREATE.id;
      this.taxReturnService.updateTaxReturnapsTaxReturnId(taxReturn.id, {apsTaxReturnId: this.apsTaxReturnId}).subscribe(() => {
        this.closeCreateTaxReturnModal();
        this.actioning = null;
        this.refresh.emit(taxReturn);
      }, () => {
        this.actioning = null;
      });
    });
  }


  showCreateTaxReturnModal(onApprove: () => void) {
    $(this.createReturnEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }

  closeCreateTaxReturnModal() {
    $(this.createReturnEl.nativeElement).modal('hide');
  }

  genericAction(taxReturn: ITaxReturn,
                action: TaxReturnAction,
                confirmationText: string,
                successText: string | ((data: any) => string),
                errorText: string,
                updateObservable: Observable<any>,
                output: EventEmitter<ITaxReturn>) {
    this.actionConfirmationText = confirmationText;
    this.showActionConfirmationModal(() => {
      this.actioning = action.id;
      updateObservable.subscribe((data: any) => {
        this.actioning = null;
        this.actionSuccessText = typeof successText === "string" ? successText : successText(data);
        this.showActionSuccessModal(() => {
          output.emit(taxReturn);
        });
      }, () => {
        this.actioning = null;
      });
    });
  }



  showActionConfirmationModal(onApprove: () => void) {
    $(this.actionConfirmationModalEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }


  doBulkAction(taxReturns: ITaxReturn[], action: TaxReturnAction, populationId: number = null, updateReturn = false) {
    // Currently max 1 action in progress
    if (this.actioning != null) {
      return;
    }
    this.taxReturns = taxReturns;

    if (action.id === TaxReturnAction.CREATE.id) {
      console.log('Action', action, "cannot be implemented in bulk");
    } else if (action.id === TaxReturnAction.PRE_PREPARE.id) {
      this.bulkPrepareTaxReturn(taxReturns, updateReturn);
    } else if (action.id === TaxReturnAction.COMPLETE_PRE_PREPARE.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would to complete PrePrepare?.`,
        "Success", "Failed",
        taxReturns.map(taxReturn => this.taxReturnService.completePrePrepare(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.PREPARE.id) {
      this.bulkPrepareTaxReturn(taxReturns);
    } else if (action.id === TaxReturnAction.REVIEW.id) {
      if (taxReturns[0].fullStatus.step === TaxReturnStep.FIRST_REVIEW) {
        this.reviewOrdinal = `first reviewer for ${taxReturns.length} ${this.taxReturnAlias}s`;
        const countSecond = taxReturns.filter(taxReturn => taxReturn.fullStatus.step !== TaxReturnStep.FIRST_REVIEW).length
        if (countSecond) {
          this.reviewOrdinal = `first reviewer for ${taxReturns.length - countSecond} ${this.taxReturnAlias}${taxReturns.length - countSecond > 1 ? 's' : ''} & second reviewer for ${countSecond} ${this.taxReturnAlias} ${countSecond > 1 ? 's' : ''}`
        }
      } else {
        this.reviewOrdinal = `second reviewer for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`;
      }
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would to set yourself as ${this.reviewOrdinal}.`,
        "Setting to review status completed", "Setting review failed",
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnWithreviewer(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.CHECK_PREFILL_RUN_CALS.id) {
      this.showBulkActionNotAvailableModalModal()
    } else if (action.id === TaxReturnAction.GENERATE_TAX_PACKAGE.id || action.id === TaxReturnAction.GENERATE_FINAL_DOCUMENTS.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you are ready to complete preparation`,
        "Setting to preparation status completed", "Setting preparation complete failed",
        taxReturns.map(taxReturn => this.taxReturnService.generatePackageStatusTransitionCheck(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.GENERATE_TAX_PACKAGE_FINAL.id || action.id === TaxReturnAction.GENERATE_FINAL_DOCUMENTS_FINAL.id) {
      this.bulkGeneratePackage();
    } else if (action.id === TaxReturnAction.GENERATE_TAX_PACKAGE_MANUAL.id) {
      this.bulkGeneratePackage();
    } else if (action.id === TaxReturnAction.PREVIEW_FINAL_PACKAGE.id) {
      this.bulkGeneratePackage();
    } else if (action.id === TaxReturnAction.RESUBMIT_EMPLOYER_FINAL_PACKAGE.id) {
      this.bulkGeneratePackage();
    } else if (action.id === TaxReturnAction.SUBMIT_FOR_REVIEW.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk submit ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''} for review`,
        "Submitted for review completed", "Submitted for review failed",
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToSubmitForReview(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.BACK_FOR_CHANGES.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk send back for changes ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        "Send back for changes completed", "Send back for changes failed",
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnSendBackForChanges(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.REVIEW_COMPLETED.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk complete the review for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        "Complete review status change completed", "Complete review status change failed",
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnReviewCompleted(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.SUBMIT_TO_ASSIGNEE.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk ${action.name} for review for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.name} status change completed`, `${action.name} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnSubmitToAssignee(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.TAXPAYER_ACCEPTED.id || action.id === TaxReturnAction.TAXPAYER_ACCEPTED_ARROW.id || action.id === TaxReturnAction.TAXPAYER_ACCEPTED_BUTTON.id || action.id === TaxReturnAction.TAXPAYER_ACCEPTED_NEXT.id) {
      this.showBulkActionNotAvailableModalModal()
    } else if (action.id === TaxReturnAction.TAXPAYER_REJECTED.id || action.id === TaxReturnAction.TAXPAYER_REJECTED_BUTTON.id || action.id === TaxReturnAction.TAXPAYER_REJECTED.id) {
      this.showBulkActionNotAvailableModalModal()
      // this.taxpayerRejected(taxReturns);
    } else if (action.id === TaxReturnAction.EMPLOYER_ACCEPTED.id || action.id === TaxReturnAction.EMPLOYER_ACCEPTED_NEXT.id || action.id === TaxReturnAction.EMPLOYER_ACCEPTED_NEXT_BUTTON.id) {
      this.showBulkActionNotAvailableModalModal()

      // this.employerAccepted(taxReturns);
    } else if (action.id === TaxReturnAction.EMPLOYER_REJECTED.id || action.id === TaxReturnAction.EMPLOYER_REJECTED_BACK.id || action.id === TaxReturnAction.EMPLOYER_REJECTED_BACK_BUTTON.id) {
      this.showBulkActionNotAvailableModalModal()

      // this.employerRejected(taxReturns);
    } else if (action.id === TaxReturnAction.TAXPAYER_EMPLOYER_ACCEPTED.id) {
      this.showBulkActionNotAvailableModalModal()

      // this.taxpayerEmployerAccepted(taxReturns);
    } else if (action.id === TaxReturnAction.TAXPAYER_EMPLOYER_REJECTED.id) {
      this.showBulkActionNotAvailableModalModal()

      // this.taxpayerEmployerRejected(taxReturns);
    } else if (action.id === TaxReturnAction.REVISE.id || action.id === TaxReturnAction.REVISE_BACK_FOR_CHANGES.id || action.id === TaxReturnAction.REVISE_BACK_FOR_CHANGES_SECONDARY.id) {
      this.showBulkActionNotAvailableModalModal()
    } else if (action.id === TaxReturnAction.LODGED.id || action.id === TaxReturnAction.LODGED_NEXT.id || action.id === TaxReturnAction.LODGED_ARROW.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk lodge ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.name} status change completed`, `${action.name} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToBeLodged(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.AMEND.id) {
      this.showBulkActionNotAvailableModalModal()
    } else if (action.id === TaxReturnAction.PROCESS_NO_QNR.id) {
      this.showBulkActionNotAvailableModalModal()
      // this.processNoQnr(taxReturns, populationId);
    } else if (action.id === TaxReturnAction.BULK_PROCESS_NO_QNR.id) {
      this.showBulkActionNotAvailableModalModal()
      // this.setBulkProcess(taxReturns, populationId);
    } else if (action.id === TaxReturnAction.EXCEPTION_FILING.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk send to ${action.name} for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.name} status change completed`, `${action.name} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToBeExceptionFiling(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.INFORMATION_NOT_COMPLETE.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk set ${action.name} for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.name} status change completed`, `${action.name} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToBePrintedInformationNotComplete(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.SEND_FOR_PRINTING.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_REJECT.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_ARROW.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_REFINE.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk ${action.title} for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.title} status change completed`, `${action.title} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToSendForPrinting(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.CHECK_PRINTED_PACKAGE.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk ${action.name} for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.name} status change completed`, `${action.name} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToCheckPrintedPackage(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND.id || action.id === TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND_ACCEPTED.id || action.id === TaxReturnAction.SEND_FOR_PRINTING_CHECKING.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk ${action.title} for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.title} status change completed`, `${action.title} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToReadyToSend(taxReturn.id)),
        this.bulkActionComplete
      )
    } else if (action.id === TaxReturnAction.QUESTION_DRIVEN_STATUS.id || action.id === TaxReturnAction.QUESTION_DRIVEN_STATUS_NEXT.id) {
      this.genericBulkAction(taxReturns,
        action,
        `Are you sure you would like to bulk change status based on an answer in the ${this.taxReturnAlias} for ${taxReturns.length} ${this.taxReturnAlias}${taxReturns.length > 1 ? 's' : ''}`,
        `${action.name} status change completed`, `${action.name} status change failed`,
        taxReturns.map(taxReturn => this.taxReturnService.updateTaxReturnToStatusDrivenByQuestion(taxReturn.id)),
        this.bulkActionComplete
      )
    } else {
      console.log('Unknown action', action);
    }
  }

  showBulkActionConfirmationModal(onApprove: () => void) {
    $(this.actionBulkConfirmationModalEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        this.closeBulkActionConfirmationModal();
        return false;
      },
    }).modal("show");
  }

  closeBulkActionConfirmationModal() {
    $(this.actionBulkConfirmationModalEl.nativeElement).modal('hide');
  }

  showCreateFinalPackageModal(onApprove: () => void) {
    $(this.createFinalPackageModalEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }

  hideCreateFinalPackageModal() {
    $(this.createFinalPackageModalEl.nativeElement).modal("hide");
  }

  showActionSuccessModal(onHidden: () => void) {
    $(this.actionSuccessModalEl.nativeElement).modal({
      onHidden,
    }).modal('show');
  }

  showActionGenerateTaxReturnModal(onHidden: () => void) {
    $(this.actionGenerateTaxReturnModalEl.nativeElement).modal({
      onHidden,
    }).modal('show');
  }

  checkPrefillRunCals(taxReturn: ITaxReturn) {
    const summary = [];
    const elem = el(this.prefillResultsModal);
    this.taxReturnService.processPrefillRunCalcs(taxReturn.id).subscribe(result => {
      if (result.processPrefillRunCalcs) {
        summary.push(`Getting Prefill for taxreturn with atlas ID ${taxReturn.atlasId}`);
      } else {
        // summary.push(`Failed to change status for taxreturn with atlas ID ${taxReturn.atlasId}`);
        // failed, error msg?
        summary.push(`No prefill found for taxreturn with atlas ID ${taxReturn.atlasId}`);
        this.clientNotificationService.appendMessage('No prefill found', 'No Prefill', false);
      }
      this.prefillResultsSummary = summary;
      elem.modal('show');
      elem.find('.content')[0].scrollTop = 0;
    }, e => {
      summary.push(`Failed to change status for taxreturn with atlas ID ${taxReturn.atlasId}`);
      elem.modal('show');
      elem.find('.content')[0].scrollTop = 0;
    });
  }

  previewFinalPackage() {
    this.openActionDialog('previewFinalPackage', {});
  }

  previewFinalPackageAU(taxReturn: ITaxReturn) {
    this.sendConfirmationEmail = true;
    this.showCreateFinalPackageModal(() => {
      const docIds = this.finalPackagePreview.documents.filter(d => d.selected).map(d => d.id);
      const sendConfirmationEmail = this.sendConfirmationEmail;
      this.actioning = TaxReturnAction.CREATE_FINAL_PACKAGE.id;
      this.taxReturnService.createFinalPackage( taxReturn.id, { docIds, sendConfirmationEmail }).subscribe(resp => {
        this.actioning = null;
        this.actionSuccessText = resp.uploadedToLink
          ? "Final package created and uploaded to LINK"
          : "Final package created but upload to LINK failed. System will automatically retry every hour.";
        this.showActionSuccessModal(() => {
          this.shouldNavigateFromTaxReturn.emit(taxReturn);
        });
      }, e => {
        this.actioning = null;
      });
    });

    this.finalPackagePreview = null;
    this.taxReturnService.getFinalPackagePreview(taxReturn.id).subscribe(data => {
      this.finalPackagePreview = data;
    }, () => {
      this.finalPackagePreview = null;
      this.hideCreateFinalPackageModal();
    });
  }

  submitForReview(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.SUBMIT_FOR_REVIEW,
      `Are you sure you want to submit this ${this.taxReturnAlias} for review?`,
      'Successfully submitted for review',
      'Failed to submit for review',
      this.taxReturnService.updateTaxReturnToSubmitForReview(taxReturn.id),
      this.shouldNavigateFromTaxReturn,
    );
  }

  backForChanges(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.BACK_FOR_CHANGES,
      `Are you sure you want to send this ${this.taxReturnAlias} back for changes?`,
      'Successfully sent back for changes',
      'Failed to send back for changes',
      this.taxReturnService.updateTaxReturnSendBackForChanges(taxReturn.id),
      this.shouldNavigateFromTaxReturn,
    );
  }

  reviewCompleted(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.REVIEW_COMPLETED,
      `Are you sure you want to complete your review of this ${this.taxReturnAlias}?`,
      'Successfully completed review',
      'Failed to complete review',
      this.taxReturnService.updateTaxReturnReviewCompleted(taxReturn.id),
      this.shouldNavigateFromTaxReturn,
    );
  }

  submitToAssignee(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.SUBMIT_TO_ASSIGNEE,
      `Are you sure you want to submit this ${this.taxReturnAlias} to the assignee for review?`,
      'Successfully submitted to assignee',
      'Failed to submit to assignee',
      this.taxReturnService.updateTaxReturnSubmitToAssignee(taxReturn.id),
      this.shouldNavigateFromTaxReturn,
    );
  }

  confirmUploadLinkManually(taxReturn: ITaxReturn) {
    const action = TaxReturnAction.LINK_FAIL_UPLOAD_NEXT;
    this.showConfirmUploadLinkManuallyModal(taxReturn, () => {
      this.actioning = action.id;
      this.taxReturnService.updateTaxReturnToStatusDrivenByQuestion(taxReturn.id).subscribe(() => {
        this.actioning = null;
        this.closeConfirmUploadLinkManuallyModal();
        this.shouldNavigateToTaxReturn.emit(taxReturn);
      }, e => {
        this.actioning = null;
      });
      return false;
    });
  }

  showConfirmUploadLinkManuallyModal(taxReturn: ITaxReturn, onApprove: () => void) {
    $(this.confirmUploadLinkManuallyEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }

  closeConfirmUploadLinkManuallyModal() {
    $(this.confirmUploadLinkManuallyEl.nativeElement).modal('hide');
  }

  taxpayerAccepted(taxReturn: ITaxReturn) {
    this.openActionDialog('approval', {});
  }


  taxpayerRejected(taxReturn: ITaxReturn) {
    if (this.configState.tenant !== Tenant.AU && this.configState.tenant !== Tenant.ESS) {
      this.openActionDialog('reject', {});
    } else {
      this.genericAction(
        taxReturn,
        TaxReturnAction.TAXPAYER_REJECTED,
        `Are you sure you want to mark this ${this.taxReturnAlias} as having been rejected by the ${this.taxpayerAlias}?`,
        `Successfully marked as ${this.taxpayerAlias} rejected`,
        `Failed to mark as ${this.taxpayerAlias} rejected`,
        this.taxReturnService.updateTaxReturnWithTaxpayerRejected(taxReturn.id),
        this.refresh,
      );
    }
  }

  employerAccepted(taxReturn: ITaxReturn) {
    this.openActionDialog('approval', {});
  }

  employerRejected(taxReturn: ITaxReturn) {
    this.openActionDialog("reject", {});
  }


  taxpayerEmployerAccepted(taxReturn: ITaxReturn) {
    this.openActionDialog('approval', {});
  }

  taxpayerEmployerRejected(taxReturn: ITaxReturn) {
    this.openActionDialog("reject", {});
  }

  completePrePrepareTaxReturn(taxReturn: ITaxReturn, updateTaxReturn = false) {
    if (updateTaxReturn) {
      this.genericAction(
        taxReturn,
        TaxReturnAction.COMPLETE_PRE_PREPARE,
        `Are you sure you would to complete PrePrepare?.`,
        "Success",
        "Failed",
        this.taxReturnService.completePrePrepare(taxReturn.id),
        this.shouldNavigateToTaxReturn,
      );
    } else {
      this.shouldNavigateToTaxReturn.emit(taxReturn);
    }
  }


  lodged(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.LODGED,
      `Are you sure you want to mark this ${this.taxReturnAlias} as having been lodged?`,
      'Successfully marked as lodged',
      'Failed to mark as lodged',
      this.taxReturnService.updateTaxReturnToBeLodged(taxReturn.id),
      this.refresh,
    );
  }

  exceptionFiling(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.EXCEPTION_FILING,
      `Are you sure you want to mark this ${this.taxReturnAlias} for exception filing?`,
      'Successfully marked for exception filing',
      'Failed to mark for exception filing',
      this.taxReturnService.updateTaxReturnToBeExceptionFiling(taxReturn.id),
      this.refresh,
    );
  }

  informationNotComplete(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.INFORMATION_NOT_COMPLETE,
      `Are you sure this ${this.taxReturnAlias} was sent for printing with incomplete information?`,
      'Successfully set to Information Not Complete',
      'Failed to set status to Information Not Complete',
      this.taxReturnService.updateTaxReturnToBePrintedInformationNotComplete(taxReturn.id),
      this.refresh,
    );
  }
  checkPrintedPackage(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.CHECK_PRINTED_PACKAGE,
      `Are you sure you want to send the printed ${this.taxReturnAlias} for review?`,
      'Successfully sent for review',
      'Failed to send for review',
      this.taxReturnService.updateTaxReturnToCheckPrintedPackage(taxReturn.id),
      this.refresh,
    );
  }
  sendForPrinting(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.SEND_FOR_PRINTING,
      `Are you sure you want to send the ${this.taxReturnAlias} for printing?`,
      'Successfully sent for printing',
      'Failed to send for printing',
      this.taxReturnService.updateTaxReturnToSendForPrinting(taxReturn.id),
      this.refresh,
    );
  }

  readyToSend(taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.PRINTED_PACKAGE_READY_TO_SEND,
      `Are you sure the ${this.taxReturnAlias} is ready to send?`,
      'Successfully set to Ready to Send',
      'Failed to set to Ready to Send',
      this.taxReturnService.updateTaxReturnToReadyToSend(taxReturn.id),
      this.refresh,
    );
  }
  questionDrivenStatus (taxReturn: ITaxReturn) {
    this.genericAction(
      taxReturn,
      TaxReturnAction.QUESTION_DRIVEN_STATUS,
      `Are you sure you want to transition the ${this.taxReturnAlias} to the next status as calculated by an answer in the ${this.taxReturnAlias}?`,
      'Successfully status transitioned',
      `Failed to transition ${this.taxReturnAlias}`,
      this.taxReturnService.updateTaxReturnToStatusDrivenByQuestion(taxReturn.id),
      this.refresh,
    );
  }

  amend(taxReturn: ITaxReturn) {
    const action = TaxReturnAction.AMEND;
    // Note: only differentiate sg and others for now
    if (this.configState.tenant !== Tenant.AU) {
      this.openActionDialog("amend", {});
    } else {
      this.apsTaxReturnId = '';
      this.showCreateAmendmentModal(() => {
        this.actioning = action.id;
        this.taxReturnService.updateTaxReturnapsTaxReturnId(taxReturn.id, { apsTaxReturnId: this.apsTaxReturnId }).subscribe(() => {
          this.actioning = null;
          this.closeCreateAmendmentModal();
          this.refresh.emit(taxReturn);
        }, e => {
          this.actioning = null;
        });
        return false;
      });
    }
  }

  handleWrongPermission(reason: string) {
    if(reason === 'YouWerePreparer') {
      this.wrongPermissionYouWerePreparer = false;
    }
    this.showWrongPermissionModal();
  }

  showCreateAmendmentModal(onApprove: () => void) {
    $(this.createAmendmentEl.nativeElement).modal({
      onApprove: () => {
        this.zone.run(onApprove);
        return false;
      },
    }).modal("show");
  }

  closeCreateAmendmentModal() {
    $(this.createAmendmentEl.nativeElement).modal('hide');
  }

  selectedDocuments(fpp: FinalPackagePreview) {
    return fpp.documents.filter(d => d.selected).length;
  }

  moveDocUp(fpp: FinalPackagePreview, index: number) {
    if (index > 0) {
      const d = fpp.documents.splice(index, 1);
      fpp.documents.splice(index - 1, 0, ...d);
    }
  }

  moveDocDown(fpp: FinalPackagePreview, index: number) {
    if (index < fpp.documents.length - 1) {
      const d = fpp.documents.splice(index, 1);
      fpp.documents.splice(index + 1, 0, ...d);
    }
  }

  processNoQnr(taxReturn: ITaxReturn, populationId: number) {
    if (populationId) {
      this.populationService.startProcess(populationId, {taxReturnId: taxReturn.id}).subscribe(() => {
          this.refresh.emit(taxReturn);
          this.disableBulkStartProcess.emit(true);
      });
    }
  }

  bulkProcessSuccess() {
    this.refresh.emit();
    this.disableAllStartProcess.emit(true);
  }

  private openActionDialog<A extends TaxReturnActionType>(action: A,  data: ITaxReturnActionDataMap[A]) {
    // Close open dialogs first to prevent multiple dialogs from being open at once
    this.dialog.closeAll();

    // Union types don't play well with the `dialog.open` parameter types so an unknown component type is
    // used here. Types are narrowed further down using instanceof checks for subscribing to events
    const component = this.getDialogComponentForAction(action) as ComponentType<unknown>;
    const dialogRef = this.dialog.open(component, {
      width: '660px',
      data: {
        taxReturn: this.taxReturn,
        ...data,
      },
      autoFocus: false,
    });

    // Set up event listeners for component specific  events
    if (dialogRef.componentInstance instanceof TemplateGenerationSelectionComponent) {
      dialogRef.componentInstance.generateCompleted.subscribe(() => {
        this.refresh.emit(this.taxReturn);
      });
    }

    if (
      dialogRef.componentInstance instanceof RejectConfirmationComponent ||
      dialogRef.componentInstance instanceof ReviseConfirmationComponent ||
      dialogRef.componentInstance instanceof TaxreturnApprovalConfirmationComponent
    ) {
      dialogRef.componentInstance.completed.subscribe(() => {
        this.refresh.emit(this.taxReturn);
      });
    }

    if (
      dialogRef.componentInstance instanceof PreviewFinalPackageComponent ||
      dialogRef.componentInstance instanceof AmendConfirmationComponent
    ) {
      dialogRef.componentInstance.completed.subscribe(() => {
        this.shouldNavigateToTaxReturn.emit(this.taxReturn);
      });
    }

    if (dialogRef.componentInstance instanceof AmendConfirmationComponent) {
      dialogRef.componentInstance.wrongPermission.subscribe((reason) => {
        this.handleWrongPermission(reason);
      });
    }
  }

  private getDialogComponentForAction(action: TaxReturnActionType) {
    switch(action) {
      case "finalPackageSelection":
        return TemplateGenerationSelectionComponent;
      case "revise":
        return ReviseConfirmationComponent;
      case "previewFinalPackage":
        return PreviewFinalPackageComponent;
      case "approval":
        return TaxreturnApprovalConfirmationComponent;
      case "reject":
        return RejectConfirmationComponent;
      case "amend":
        return AmendConfirmationComponent;
    }
  }

  private setBulkProcess(taxReturn: ITaxReturn, populationId: number) {
    if (populationId) {
      this.dialog.open(BulkProcessNoQnrComponent, {
        width: "560px",
        data: { populationId },
        autoFocus: 'dialog',
      }).afterClosed().subscribe((success: boolean) => {
        if (success) {
          this.bulkProcessSuccess();
        }
      });
    }
  }

  getFolderDisplayName() {
    if (this.configState.tenant === Tenant.AU || this.configState.tenant === Tenant.ESS || this.configState.tenant === Tenant.SG) {
      return "DocShare";
    }
    if (this.configState.tenant === Tenant.CN || this.configState.tenant === Tenant.HK) {
      return "cnDocs";
    }
    return "Folder";
  }
}
